
<div>
    <div class=" pr-0 ">
        <div class=" ml-0 pr-0 pl-0">
            <div v-for="(item, index) in all" :key = "index">
                <p-audit-select-item
                    :index    = "index+1"
                    :selected      = "selected(item)"
                    :item          = "item"
                    selected-color = "black--text"
                />
                <v-divider />
            </div>
        </div>

        <v-row class="no-frame pa-3 mt-5">
            <v-col class="no-frame">
                <p-audit-measure
                    label="Maßnahmen aus der Betriebsanleitung des Herstellers"
                    :text="manufacturerMeasures"
                />
            </v-col>
        </v-row>

        <v-row class="no-frame mt-0 pa-3">
            <v-col class="no-frame">
                <p-audit-measure
                    label="Weitere vom Betreiber festgelegte Sicherheitsmaßnahmen"
                    :text="customerMeasures"
                />
            </v-col>
        </v-row>
    </div>
</div>
